/**
 * Identifies the message transaction type.
 * tag: 2811
 * @readonly
 * @enum {number} (int)
 */
export enum PayRequestTransType {
  /** New */
  New = 0,
  /** Cancel */
  Cancel = 1,
}
